import React, { FC } from 'react';
import { Breakpoint, Typography } from '@altibox/design-system-component-lib';

import { i18n } from 'app/i18n';
import { wifiImageProps } from 'app/resources/images';
import { I18nUtils } from 'app/utils/i18n-utils';
import { Link } from 'app/components/link';
import { config } from 'app/config/config';

import { SuccessInformation, SuccessInformationProps } from './success-information/success-information';

interface OwnProps {
    isHomeGatewayUpgradeNeeded: boolean;
}

type Props = OwnProps & Pick<SuccessInformationProps, 'loading'>;

export const EquipmentInformation: FC<Props> = (props) => {
    const { isHomeGatewayUpgradeNeeded, ...rest } = props;

    return (
        <SuccessInformation
            {...rest}
            icon={wifiImageProps}
            title={i18n.page.success.equipment.title}
            description={
                <Typography variant="paragraph2" component="span" maxBreakpoint={Breakpoint.TABLET}>
                    {isHomeGatewayUpgradeNeeded && `${i18n.page.success.equipment.newHomeGateway} `}
                    {I18nUtils.richMessage(i18n.page.success.equipment.description, {
                        linkToGetStartedPage: (
                            <Link
                                variant="paragraph2"
                                maxBreakpoint={Breakpoint.TABLET}
                                href={config.GET_STARTED_PAGE_URL}
                            >
                                {i18n.page.success.equipment.linkToGetStartedPage}
                            </Link>
                        ),
                    })}
                </Typography>
            }
        />
    );
};
